import { Shark, SmartModel } from "shark-mvc";

class ResinSystem extends SmartModel {
	area = 0;
	baseCoats = {
		Aquareg1: false,
		Aquareg1Area: 0,
		Aquareg2: false,
		Aquareg2Area: 0,
		Aquareg2Plus: false,
		Aquareg2PlusArea: 0,
		Tecnireg1: false,
		Tecnireg1Area: 0,
		Tecnireg2: false,
		Tecnireg2Area: 0,
		Tecnireg2Plus: false,
		Tecnireg2PlusArea: 0,
	};
	jobType = "";
	jobTypeSpec = "";
	otherSystemNote = "";
	pasteColor = "";
	preparation = "";
	proposalGroup = -1;
	ralColor = "";
	scope = "";
	system = "";
	systemNote = "";
	substrateType = "";
	thickness = 0;

	__isNewJob = false;
	__isOtherSystem = false;
	__isRemakeJob = false;
	__jobTypeLabel = "";

	constructor (data) {
		super(data);

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.baseCoats = this.exportObjectField("baseCoats");

		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		this.importNumberField("area", data.area);
		this.importNumberField("proposalGroup", data.proposalGroup);
		this.importNumberField("thickness", data.thickness);

		this.__jobTypeLabel = this.jobType === "new" ? "INTERVENTO SUL NUOVO" : "INTERVENTO DI RIPRISTINO/RIFACIMENTO";
		this.__isNewJob = this.jobType === "new";
		this.__isOtherSystem = this.system === "ALTRO";
		this.__isRemakeJob = this.jobType === "remake";
	}

	isValid () {
		this.validate();

		return this.__isValid;
	}

	onDataChanged (data) {
		switch (data.property) {
			case "system": {
				//Dave: Questa cosaì è pericolosissima, dovrei darre un ID a tutti i Sistemi
				const wasOtherSystem = this.__isOtherSystem;
				this.__isOtherSystem = data.newValue === "ALTRO";

				if (wasOtherSystem !== this.__isOtherSystem) {
					//Dave: Anche il render da qui non mi piace
					Shark.render();
				}
				break;
			}
			case "jobType":
				this.__isNewJob = data.newValue === "new";
				this.__isRemakeJob = data.newValue === "remake";
				break;
		}
		console.log(data, this);
	}

	validate() {
		const errors = [];
		this.__errors = {};
		this.__errorsCount = 0;

		if (this.systems.length === 0) {
			errors.push("Devi inserire almeno un'Area di Utilizzo");
			this.__errors.systems = true;
			this.__errorsCount++;
		}
		else {
			this.systems.forEach((interventionArea/*, interventionAreaIndex*/) => {
				const proposalGroupCounts = {
					0: 0,
					1: 0,
					2: 0,
					3: 0,
					4: 0,
					5: 0,
				};

				if (interventionArea.systems.length === 0) {
					errors.push("Devi inserire almeno un sistema in ogni Area di Utilizzo");
					this.__errorsCount++;
				}
				else {
					interventionArea.systems.forEach((system/*, index*/) => {
						if (system.proposalGroup === "" || system.proposalGroup === -1) {
							errors.push("Devi indicare la proposta per tutti i sitemi");
							this.__errors.proposalGroup = true;
							this.__errorsCount++;
						}
						else {
							proposalGroupCounts[system.proposalGroup]++;
						}
						if (system.system === "") {
							errors.push("Devi scegliere un sistema in ogni proposta inserita");
							this.__errors.systems = true;
							this.__errorsCount++;
						}
						if (system.system === "ALTRO" && system.otherSystemNote.trim() === "") {
							errors.push("Devi dare indicazioni dove hai scelto 'altro' come Sistema");
							this.__errors.systems = true;
							this.__errorsCount++;
						}
					});
				}

				// for (let prop in proposalGroupCounts) {
				// 	if (proposalGroupCounts[prop] > 1) {
				// 		errors.push("Nell'area di utilizzo '" + interventionArea.premiseDestination + "' (numero " + (interventionAreaIndex + 1) + ") ci sono proposte ripetute, devi indicare un valore diverso per ogni Sistema inserito");
				// 		this.__errors.proposalGroup = true;
				// 		this.__errorsCount++;
				// 	}
				// }
			});
		}

		this.__isValid = this.__errorsCount === 0;

		return errors;
	}
}

Shark.registerModel("ResinSystem", ResinSystem);

export default ResinSystem;